var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"fill":_vm.fill,"stroke":_vm.stroke,"stroke-width":_vm.strokeWidth,"points":"\n    0,16\n    13.856,8\n    13.856,-8\n    0,-16\n    -13.856,-8\n    -13.856,8\n    0,16\n  "}})}
var staticRenderFns = []

export { render, staticRenderFns }